"use client"

import { useState } from "react"
import { Textarea } from "@/components/ui/textarea"
import { Label } from "@/components/ui/label"
import { Button } from "@/components/ui/button"

export function SystemInstructions() {
  const defaultInstructions =
    "You are a helpful AI voice assistant designed to provide excellent customer support. Your goal is to be friendly, professional, and efficient.\n\nKey guidelines:\n- Always greet the caller warmly\n- Listen carefully to their needs\n- Provide clear and concise answers\n- Ask clarifying questions when needed\n- End the call with a summary and next steps"

  const [instructions, setInstructions] = useState(() => {
    try {
      const saved = localStorage.getItem("voiceAgent.systemPrompt")
      return saved ?? defaultInstructions
    } catch (e) {
      return defaultInstructions
    }
  })

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="instructions" className="text-base font-medium">
          System Instructions
        </Label>
        <p className="text-sm text-muted-foreground mt-1 mb-3">
          Define the behavior and personality of your AI voice agent
        </p>
      </div>
      <Textarea
        id="instructions"
        value={instructions}
        onChange={(e) => setInstructions(e.target.value)}
        className="min-h-[400px] font-mono text-sm"
        placeholder="Enter system instructions..."
      />
      <div className="flex justify-end gap-2">
        <Button
          variant="outline"
          onClick={() => {
            setInstructions(defaultInstructions)
            try {
              localStorage.removeItem("voiceAgent.systemPrompt")
            } catch (e) {
              /* ignore */
            }
          }}
        >
          Reset
        </Button>
        <Button
          onClick={() => {
            try {
              localStorage.setItem("voiceAgent.systemPrompt", instructions)
            } catch (e) {
              console.error("Could not save system instructions", e)
            }
          }}
        >
          Save Changes
        </Button>
      </div>
    </div>
  )
}
